export const ACTION = {
  name: 'PILLAR_CREATION'
}